module.exports = __webpack_public_path__ + "static/media/mergecard.757caa20.gif";